import React from "react";
import classnames from "classnames";
import ReactSwitch from "react-switch";
import {
    EyeIcon,
    HeartIcon,
    PencilIcon,
    TrashIcon,
} from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Tooltip } from "@mui/material";
import { uuid } from "uuidv4";

import {
    store as generalSettingStore,
    setNumberArchived,
    setNumberActive,
    setIsActivation,
    setIsValidateArchiveOpened,
    setIsActionsClicked,
    setIsEdited,
    setActions,
    setIsLoading,
    setKey,
} from "../store";
import { store } from "@components/VerticalLayout/store";
import { generalConfigStore, setItemsDisable } from "@store";

import TimePastSvgIcon from "@components/Common/SvgIcons/TimePastSvgIcon";
import ErrorToast from "@components/Common/ErrorTost/index";
import ConsultSvgIcon from "@components/Common/SvgIcons/ConsultSvgIcon";
import {
    setActivationDeactivationMessageModalOpened,
    setMessage,
    setYesFunction,
} from "@components/Common/ConfirmationActivationDeactivationMessageModal/store";
import {
    apiRequest,
    ArchivedLanguages,
    ArchivedLanguagesFranchise,
    AssociateLangues,
    createDataLanguage,
    createLanguageItem,
    isLanguageConsumed,
} from "../hooks";
import { ShowSuccessToast } from "../ShowSuccessToast";
import { useFetchGlobal } from "../../../../api/hooks";

type CustomIconsType = {
    e: any;
    isArchivedLanguagesClicked: boolean;
    setDataState: Function;
    setModalState: Function;
    modalState: any;
    tableState: any;
    setTableState: Function;
};

export function CustomIcons({
    e,
    isArchivedLanguagesClicked,
    setDataState,
    setModalState,
    modalState,
    tableState,
    setTableState,
}: CustomIconsType) {
    const { fetchGlobal } = useFetchGlobal();
    const { t } = useTranslation();
    const {
        numberArchived,
        numberActive,
        shopsLanguagesData,
        archivedLanguageFranchise,
        isActionsClicked,
        isEdited,
        modify,
        languagesData,
        isLoading,
    } = useSnapshot(generalSettingStore);
    const { userID, franchiseID, oneShop, operatorID } = useSnapshot(store);
    const { itemsDisable } = useSnapshot(generalConfigStore);

    const [languageState, setLanguageState] = React.useState<boolean>(
        e.selectedRow.isActive
    );

    const [activeclick, setActiveclick] = React.useState<boolean>(true);
    const uuidUser = localStorage.getItem("uuidUser");

    let dataArchive = !oneShop
        ? ArchivedLanguages(shopsLanguagesData)
        : ArchivedLanguagesFranchise(archivedLanguageFranchise);

    async function activeLanguage() {
        toast.dismiss();
        const id = e.selectedRow.Id;
        let dataLanguage = createDataLanguage(
            e.selectedRow,
            userID,
            franchiseID,
            operatorID,
            uuidUser,
            id,
            e.selectedRow.shopId === "0" ? true : e.selectedRow.isActive,
            false,
            e.selectedRow.isFavorite
        );
        try {
            const result: any = await apiRequest(dataLanguage, fetchGlobal);
            if (result.error) {
                throw new Error("error");
            }
            if (
                e.selectedRow.isActive === false &&
                itemsDisable.find(
                    (item: any) =>
                        item.id === id && item.shopId === e.selectedRow.shopId
                ) === undefined &&
                e.selectedRow.shopId !== "0"
            ) {
                const item = [
                    ...JSON.parse(JSON.stringify(itemsDisable)),
                    {
                        id: id,
                        state: e.selectedRow.isActive,
                        shopId: e.selectedRow.shopId,
                    },
                ];
                setItemsDisable(item);
            }
            ShowSuccessToast(
                `${t("The language was successfully unarchived")}`
            );
            setIsLoading(false);
            setKey(uuid());
        } catch (e) {
            ErrorToast(`${t("There's an error")}`);
            setIsLoading(false);
        }
    }

    async function favoriteLanguage(isFavorite: boolean) {
        if (isLoading === false) {
            setIsLoading(true);
            toast.dismiss();
            let updatedLanguage: any = {};
            languagesData.forEach((language: any) => {
                let langueObject: any = JSON.parse(JSON.stringify(language));
                if (
                    langueObject.Id === e.selectedRow.Id ||
                    langueObject.isFavorite === true
                ) {
                    Object.assign(updatedLanguage, {
                        ...createLanguageItem(
                            langueObject,
                            langueObject.Id,
                            langueObject.isActive,
                            langueObject.isArchived,
                            langueObject.Id === e.selectedRow.Id
                                ? isFavorite
                                : false,
                            langueObject.shopId
                        ),
                    });
                }
            });
            let dataLanguage = {
                userId: userID,
                shopId: [e.selectedRow.shopId],
                franchiseId: franchiseID,
                operatorId: operatorID,
                uuidUser: uuidUser,
                isShop: false,
                data: { [e.selectedRow.shopId.toString()]: updatedLanguage },
                updateFavorite: true,
            };
            let dataAssociate = !oneShop
                ? AssociateLangues(shopsLanguagesData, e.selectedRow, [
                      e.selectedRow,
                  ])
                : [];

            if (dataAssociate.length > 1) {
                setTableState({
                    ...tableState,
                    rowData: {
                        ...e.selectedRow,
                        isFavorite: !e.selectedRow.isFavorite,
                    },
                    shopId: e.selectedRow.shopId,
                    language: {
                        ...e.selectedRow,
                        isFavorite: !e.selectedRow.isFavorite,
                    },
                    selectedElement: e,
                    isConsult: false,
                    objectData: {
                        [e.selectedRow.shopId.toString()]: updatedLanguage,
                    },
                });
                setIsLoading(false);
                setIsActivation(false);
                setModalState({ ...modalState, isAssociateModified: true });
            } else {
                const updateFavorite = true;
                try {
                    const result: any = await apiRequest(
                        dataLanguage,
                        fetchGlobal,
                        updateFavorite
                    );
                    if (result.error) {
                        throw new Error("error");
                    }
                    ShowSuccessToast(
                        isFavorite
                            ? `${
                                  dataAssociate.length > 1
                                      ? t(
                                            "Franchise favorite state has been successfully activated"
                                        )
                                      : t(
                                            "Favorite state has been enabled successfully"
                                        )
                              }`
                            : `${
                                  dataAssociate.length > 1
                                      ? t(
                                            "Franchise favorite state has been successfully deactivated"
                                        )
                                      : t(
                                            "Favorite state has been disabled successfully"
                                        )
                              }`
                    );
                    setIsLoading(false);
                    setKey(uuid());
                } catch (e) {
                    ErrorToast(`${t("There's an error")}`);
                    setIsLoading(false);
                }
            }
        }
    }
    async function enableLanguage() {
        toast.dismiss();
        const id = e.selectedRow.Id;
        let dataLanguage = createDataLanguage(
            e.selectedRow,
            userID,
            franchiseID,
            operatorID,
            uuidUser,
            id,
            !languageState,
            e.selectedRow.isArchived,
            e.selectedRow.isFavorite
        );
        const isStateChange = true;

        try {
            const result: any = await apiRequest(
                dataLanguage,
                fetchGlobal,
                isStateChange
            );
            if (result.error) {
                throw new Error("error");
            }
            if (
                !languageState === false &&
                itemsDisable.find(
                    (item: any) =>
                        item.id === id && item.shopId === e.selectedRow.shopId
                ) === undefined
            ) {
                const item = [
                    ...JSON.parse(JSON.stringify(itemsDisable)),
                    {
                        id: id,
                        state: !languageState,
                        shopId: e.selectedRow.shopId,
                    },
                ];
                setItemsDisable(item);
                localStorage.setItem("itemsDisable", JSON.stringify(item));
            } else if (!languageState === true) {
                const item = itemsDisable.filter(
                    (item: any) =>
                        !(
                            item.id === id &&
                            item.shopId === e.selectedRow.shopId
                        )
                );
                setItemsDisable(item);
                localStorage.setItem("itemsDisable", JSON.stringify(item));
            }
            setTableState({
                ...tableState,
                dataIsUpdated: !tableState.dataIsUpdated,
            });
            ShowSuccessToast(
                languageState
                    ? `${t("The language was successfully deactivated")}`
                    : `${t("The language was successfully activated")}`
            );
        } catch (e) {
            ErrorToast(`${t("There's an error")}`);
        }
    }

    function consultAction() {
        setTableState({
            ...tableState,
            rowData: e.selectedRow,
            shopId: e.selectedRow.shopId,
            language: e.selectedRow,
            selectedElement: e,
            isConsult: true,
        });
        setModalState({
            ...modalState,
            isAddLanguageClicked: true,
        });
    }
    function favoriteAction() {
        let dataAssociate = !oneShop
            ? AssociateLangues(shopsLanguagesData, e.selectedRow, [
                  e.selectedRow,
              ])
            : [];
        setModalState({
            ...modalState,
            isAddLanguageClicked: false,
        });
        if (
            e.selectedRow.isActive === false &&
            oneShop &&
            e.selectedRow.isFavorite === false
        ) {
            ErrorToast(
                t(
                    "Please note, you cannot activate the favorite state for a disabled language"
                )
            );
        } else {
            if (dataAssociate.length <= 1) {
                setTableState({
                    ...tableState,
                    rowData: {
                        ...e.selectedRow,
                        isFavorite: !e.selectedRow.isFavorite,
                    },
                    shopId: e.selectedRow.shopId,
                    language: {
                        ...e.selectedRow,
                        isFavorite: !e.selectedRow.isFavorite,
                    },
                    selectedElement: e,
                    isConsult: false,
                });
            }
            favoriteLanguage(!e.selectedRow.isFavorite);
        }
    }
    function editAction() {
        setModalState({
            ...modalState,
            isAddLanguageClicked: true,
        });
        setTableState({
            ...tableState,
            rowData: e.selectedRow,
            shopId: e.selectedRow.shopId,
            language: e.selectedRow,
            selectedElement: e,
            localFilterActive: false,
        });
    }
    function SwitchAction() {
        setIsLoading(false);
        setModalState({
            ...modalState,
            isAddLanguageClicked: false,
        });
        let dataAssociate = !oneShop
            ? AssociateLangues(shopsLanguagesData, e.selectedRow, [
                  e.selectedRow,
              ])
            : [];

        if (e.selectedRow.isFavorite === true) {
            ErrorToast(
                t("Please note, you cannot deactivate a favorite language")
            );
        } else if (dataAssociate.includes(e.selectedRow.Id)) {
            setIsActivation(true);
            setModalState({
                ...modalState,
                isAssociateModified: true,
            });
        } else {
            setMessage(
                languageState
                    ? t(
                          "Caution, the language may be used by other modules.\n Would you like to confirm the deactivation of the selected language?"
                      )
                    : t(
                          "Would you like to confirm the activation of the selected language?"
                      )
            );
            setYesFunction(() => {
                setLanguageState(!languageState);
                enableLanguage();
                setDataState({
                    id: e.selectedRow.Id,
                    state: !languageState,
                });
            });

            setActivationDeactivationMessageModalOpened(true);
        }
        setTableState({
            ...tableState,
            selectedElement: e,
        });
    }
    async function trashAction() {
        setIsLoading(false);
        setModalState({
            ...modalState,
            isAddLanguageClicked: false,
        });
        setIsEdited(false);
        let dataAssociate = !oneShop
            ? AssociateLangues(shopsLanguagesData, e.selectedRow, [
                  e.selectedRow,
              ])
            : [];
        if (e.selectedRow.isFavorite === true) {
            ErrorToast(
                t("Please note, you cannot archive a favorite language")
            );
        } else if (dataAssociate.length > 1) {
            ErrorToast(
                `${t(
                    "Please note that you cannot archive an item assigned to stores."
                )!}`
            );
        } else {
            let isConsumed = await isLanguageConsumed(
                e,
                t,
                franchiseID,
                fetchGlobal
            );
            if (isConsumed === true) {
                ErrorToast(
                    `${t(
                        "Please note, you cannot archive an element used in a template"
                    )!}`
                );
            } else {
                setTableState({
                    ...tableState,
                    selectedRows: [e.selectedRow],
                });
                setIsValidateArchiveOpened(true);
            }
        }
    }
    function historyAction() {
        setModalState({
            ...modalState,
            isAddLanguageClicked: false,
        });
        setIsEdited(false);
        setTableState({
            ...tableState,
            selectedRows: [e.selectedRow],
            rowData: e.selectedRow,
        });
        setModalState({
            ...modalState,
            isHistoryModalOpened: !modalState.isHistoryModalOpened,
        });
    }
    return (
        <React.Fragment>
            {e.selectedRow?.subRows === undefined ? (
                <div className="d-flex justify-content-around">
                    {modify === false ? (
                        <Tooltip title={t("To consult")}>
                            <div>
                                <ConsultSvgIcon
                                    className="pointer__clz afa_icn_toConsult"
                                    height={35}
                                    width={35}
                                    style={{
                                        cursor: "pointer",
                                        position: "relative",
                                        bottom: "5px",
                                    }}
                                    fill="black"
                                    onClick={() => {
                                        if (isEdited === true) {
                                            setIsActionsClicked(
                                                !isActionsClicked
                                            );
                                            setActions(() => {
                                                setIsEdited(false);
                                                consultAction();
                                            });
                                        } else {
                                            consultAction();
                                        }
                                    }}
                                />
                            </div>
                        </Tooltip>
                    ) : null}
                    {modify === true ? (
                        <>
                            <Tooltip
                                title={
                                    isArchivedLanguagesClicked ||
                                    e.selectedRow.isFavorite === true
                                        ? ""
                                        : t("Enable favorite state")
                                }
                            >
                                <div>
                                    <HeartIcon
                                        onClick={() => {
                                            if (
                                                e.selectedRow.isFavorite ===
                                                false
                                            ) {
                                                setIsLoading(true);
                                                if (isEdited === true) {
                                                    setIsLoading(false);
                                                    setIsActionsClicked(
                                                        !isActionsClicked
                                                    );
                                                    setActions(() => {
                                                        setIsEdited(false);
                                                        favoriteAction();
                                                    });
                                                } else {
                                                    setIsLoading(false);
                                                    favoriteAction();
                                                }
                                            }
                                        }}
                                        height={25}
                                        width={25}
                                        name="heart"
                                        fill={
                                            e.selectedRow.isFavorite
                                                ? "red"
                                                : "black"
                                        }
                                        className={`${classnames(
                                            "lan_icn_FRlike",
                                            {
                                                pointer__clz:
                                                    e.selectedRow.isFavorite ===
                                                    false,
                                            },
                                            {
                                                "not-allowed-icon__clz":
                                                    isArchivedLanguagesClicked ||
                                                    isLoading,
                                            },
                                            oneShop ? "mr-2" : ""
                                        )}`}
                                    />
                                </div>
                            </Tooltip>
                            <Tooltip
                                title={
                                    isArchivedLanguagesClicked
                                        ? ""
                                        : t("To modify")
                                }
                            >
                                <div>
                                    <PencilIcon
                                        onClick={() => {
                                            if (isEdited === true) {
                                                setIsActionsClicked(
                                                    !isActionsClicked
                                                );
                                                setActions(() => {
                                                    setIsEdited(false);
                                                    editAction();
                                                });
                                            } else {
                                                editAction();
                                            }
                                        }}
                                        height={25}
                                        width={25}
                                        style={{ cursor: "pointer" }}
                                        className={`${classnames(
                                            "pointer__clz cmn_icn_FRedit",
                                            {
                                                "not-allowed-icon__clz":
                                                    isArchivedLanguagesClicked ||
                                                    isLoading,
                                            },
                                            oneShop ? "mr-2" : "ml-3"
                                        )}`}
                                    />
                                </div>
                            </Tooltip>
                            {oneShop && (
                                <Tooltip
                                    title={
                                        isArchivedLanguagesClicked
                                            ? ""
                                            : languageState === false
                                            ? t("Activate")
                                            : t("Unactivate")
                                    }
                                >
                                    <div>
                                        <ReactSwitch
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            handleDiameter={26}
                                            offColor="#f7b4b8"
                                            offHandleColor="#E30613"
                                            checked={languageState}
                                            onChange={async () => {
                                                setIsLoading(true);
                                                if (isEdited === true) {
                                                    setIsLoading(false);
                                                    setIsActionsClicked(
                                                        !isActionsClicked
                                                    );
                                                    setActions(() => {
                                                        setIsEdited(false);
                                                        SwitchAction();
                                                    });
                                                } else {
                                                    SwitchAction();
                                                }
                                            }}
                                            onColor="#c2eddd"
                                            onHandleColor="#34C38F"
                                            width={50}
                                            height={20}
                                            className={`${classnames(
                                                "pointer__clz",
                                                {
                                                    "not-allowed-icon__clz":
                                                        isArchivedLanguagesClicked ||
                                                        isLoading,
                                                },
                                                oneShop ? "mr-2" : "ml-3"
                                            )}`}
                                        />
                                    </div>
                                </Tooltip>
                            )}

                            {!isArchivedLanguagesClicked ? (
                                <Tooltip title={t("Archive")}>
                                    <div>
                                        <TrashIcon
                                            onClick={async () => {
                                                if (isLoading === false) {
                                                    setIsLoading(true);
                                                    if (isEdited === true) {
                                                        setIsLoading(false);
                                                        setIsActionsClicked(
                                                            !isActionsClicked
                                                        );
                                                        setActions(async () => {
                                                            trashAction();
                                                        });
                                                    } else {
                                                        trashAction();
                                                    }
                                                }
                                            }}
                                            height={25}
                                            width={25}
                                            fill="red"
                                            style={{
                                                cursor: "pointer",
                                            }}
                                            className={`${classnames(
                                                "pointer__clz cmn_icn_FRarchived",
                                                {
                                                    "not-allowed-icon__clz":
                                                        isArchivedLanguagesClicked ||
                                                        isLoading,
                                                },
                                                oneShop ? "mr-2" : "ml-3"
                                            )}`}
                                        />
                                    </div>
                                </Tooltip>
                            ) : (
                                <Tooltip
                                    title={
                                        dataArchive.includes(
                                            e.selectedRow.Id
                                        ) && oneShop
                                            ? ""
                                            : t("Unarchive")
                                    }
                                >
                                    <div>
                                        <EyeIcon
                                            height={25}
                                            width={25}
                                            onClick={() => {
                                                setIsLoading(true);
                                                setTableState({
                                                    ...tableState,
                                                    selectedRows: [
                                                        e.selectedRow,
                                                    ],
                                                    rowData: e.selectedRow,
                                                });
                                                if (
                                                    dataArchive.includes(
                                                        e.selectedRow.Id
                                                    ) &&
                                                    !oneShop
                                                ) {
                                                    setModalState({
                                                        ...modalState,
                                                        isModalOpened: !modalState.isModalOpened,
                                                    });
                                                    setIsLoading(false);
                                                } else {
                                                    setActiveclick(false);
                                                    activeLanguage();
                                                    setNumberActive(
                                                        numberActive + 1
                                                    );
                                                    setNumberArchived(
                                                        numberArchived - 1
                                                    );
                                                    setIsLoading(false);
                                                }
                                            }}
                                            style={{
                                                cursor: "pointer",
                                            }}
                                            className={`${classnames(
                                                "pointer__clz cmn_icn_FRunarchive",
                                                {
                                                    "not-allowed-icon__clz":
                                                        !activeclick ||
                                                        isLoading,
                                                },
                                                {
                                                    "not-allowed-icon__clz":
                                                        dataArchive.includes(
                                                            e.selectedRow.Id
                                                        ) && oneShop,
                                                },
                                                oneShop ? "mr-2" : "ml-3"
                                            )}`}
                                        />
                                    </div>
                                </Tooltip>
                            )}
                        </>
                    ) : null}
                    <Tooltip title={t("Consult history")}>
                        <div>
                            <TimePastSvgIcon
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    if (isEdited === true) {
                                        setIsActionsClicked(!isActionsClicked);
                                        setActions(() => {
                                            historyAction();
                                        });
                                    } else {
                                        historyAction();
                                    }
                                }}
                                className={classnames(
                                    "pointer__clz cmn_icn_FRhistory",
                                    oneShop ? "mr-2" : "ml-3",
                                    {
                                        "not-allowed-icon__clz": isLoading,
                                    }
                                )}
                            />
                        </div>
                    </Tooltip>
                </div>
            ) : null}
        </React.Fragment>
    );
}
